import type { QueryClient } from '@tanstack/react-query'
import { invalidateTrashQueries } from './query-keys'

/**
 * ゴミ箱の中身を変える書き込み（ゴミ箱へ移動・復元・完全削除・空にする）を実行し、
 * 成功したときだけゴミ箱一覧を invalidate して結果をそのまま返す。
 * どの画面から呼んでも一覧が古いまま残らないよう、書き込みの全入口でこれを通す。
 * 202（バックグラウンド継続）も成功扱い。network error の reject はそのまま伝播する。
 */
export const invalidateTrashOnSuccess = async <R extends {error?: unknown}>(
  queryClient: QueryClient,
  write: () => Promise<R>,
): Promise<R> => {
  const result = await write()
  if (!result.error) void invalidateTrashQueries(queryClient)
  return result
}
